import React from 'react';
import { Link } from 'react-router-dom';
import './CaseStudyCard.css';

/**
 * Case-study teaser card. `variant="row"` renders the wide image-beside-text
 * layout used by the listing page; the default vertical layout matches
 * BlogCard so the same component drops into PostCarousel (e.g. "related
 * case studies") without extra styling.
 */
const CaseStudyCard = ({ post, variant = 'card' }) => (
  <article className={`case-study-card ${variant === 'row' ? 'case-study-card-row' : ''}`}>
    <div className="case-study-card-media">
      <img src={post.listingImage || post.image} alt={post.industry} />
    </div>
    <div className="case-study-card-body">
      <span className="case-study-card-branch">{post.branch}</span>
      <h3 className="case-study-card-title">
        <Link to={`/case-studies/${post.slug}`}>{post.title}</Link>
      </h3>
      <p className="case-study-card-excerpt">{post.excerpt}</p>
      <Link to={`/case-studies/${post.slug}`} className="case-study-card-more">
        Case Study lesen &rarr;
      </Link>
    </div>
  </article>
);

export default CaseStudyCard;
